import { verificationCancel } from 'model/flows/verification.model';
import { sendEvent } from 'model/helpers/events.model';
import { h } from 'preact';
import { css } from 'linaria';
import { ErrorLayout } from 'features/verify/ui/error-layout';
import { useLocalization } from 'model/localization.model';
import { useState } from 'preact/hooks';
import { Button } from 'ui/atoms/button';
import { Link } from 'ui/atoms/link';

const subClass = css`
	text-align: center;
	margin-bottom: auto;
`;

export const PoorCameraQuality = () => {
	const t = useLocalization();
	const [start] = useState(Date.now());

	return (
		<ErrorLayout
			title={t('resolution.err.title')}
			description={t('resolution.err.subtitle')}
		>
			<Link
				href={t('resolution.err.subtitle.url')}
				target={'_blank'}
				className={subClass}
			>
				{t('resolution.err.subtitle.sub')}
			</Link>
			<Button
				name={'resolution.err.btn'}
				onClick={() => {
					verificationCancel();
					sendEvent({
						event: 'poor_camera_quality_exit_clicked',
						event_attributes: {
							duration: Date.now() - start,
						},
					});
				}}
			>
				{t('resolution.err.btn')}
			</Button>
		</ErrorLayout>
	);
};
